import {
  GraphQLList,
  GraphQLInt,
  GraphQLObjectType,
  GraphQLNonNull
} from 'graphql'
import { LibraryUsageItem, libraryClassUsageItemType } from './library-usage'

export interface LibraryUsagePage {
  readonly items: LibraryUsageItem[]
  readonly total: number
}

export const libraryUsagePageType = new GraphQLObjectType({
  name: 'LibraryUsagePage',
  fields: () => ({
    items: {
      type: new GraphQLNonNull(new GraphQLList(libraryClassUsageItemType))
    },
    total: {
      type: new GraphQLNonNull(GraphQLInt)
    }
  })
})
